import React, { useEffect, useState } from "react";
import { MegaphoneIcon, CheckIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const CustomPrivacySection = ({ isChecked, onCheckChange }) => {
  const [checked, setChecked] = useState(isChecked);
  const { t } = useTranslation();

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setChecked(newValue);
    onCheckChange?.(newValue);
  };

  return (
    <div className="flex flex-col items-center justify-center p-6 my-10 bg-white">
      {/* Header Section */}
      <div className="flex items-center gap-2">
        <MegaphoneIcon className="w-6 h-6 text-black" />
        <h2 className="text-lg font-normal text-black lg:text-3xl">
          {t("VerifyOrderQuality")}
        </h2>
      </div>

      {/* Message Section */}
      <p className="mt-4 text-sm text-center text-gray-600 lg:text-lg">
        {t("OrderInspectionDetails")}
      </p>

      <div className="flex items-center gap-2 mt-2 text-green-600 cursor-pointer">
        <div
          className={`relative w-3 h-3 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 ${
            checked
              ? "bg-green-600 border-green-600"
              : "bg-white border-gray-300"
          }`}
        >
          {checked && <CheckIcon className="w-4 h-4 text-white" />}
          <input
            type="checkbox"
            className="absolute inset-0 opacity-0 cursor-pointer"
            checked={checked}
            onChange={handleChange}
          />
        </div>
        <label className="text-sm font-medium cursor-pointer lg:text-xl">
          {checked ? t("Selected") : t("FreeInspectionRequest")}
        </label>
      </div>
    </div>
  );
};

export default CustomPrivacySection;
